type NormalizeOptions = {
  size?: number;
};
export const normalizeNftUrl = (
  url: string,
  { size = 1000 }: NormalizeOptions = {}
) => {
  if (url.match(/^https:\/\/[\w|\d]+\.googleusercontent\.com\//)) {
    return url.replace(/=s\d+$/, `=s${size}`);
  }
  return url;
};
